import axios from 'axios';
import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/unwrapApiResponse';

const apiBase = process.env.REACT_APP_API_BASE_URL;

const unwrapPublicResponse = (response) => {
  const body = response.data;

  if (!body?.success) {
    const error = new Error(body?.message || 'Request failed');
    error.errors = body?.errors || [];
    error.status = response.status;
    throw error;
  }

  return body.data;
};

export const submitVpsHostingRequest = async (payload) => {
  const response = await axios.post(`${apiBase}/api/vps-hosting-requests`, payload);
  return unwrapPublicResponse(response);
};

export const getVpsHostingRequests = async () => {
  const response = await axiosClient.get('/api/admin/vps-hosting-requests');
  return unwrapApiResponse(response);
};

export const getVpsHostingRequestById = async (id) => {
  const response = await axiosClient.get(`/api/admin/vps-hosting-requests/${id}`);
  return unwrapApiResponse(response);
};

export const deleteVpsHostingRequest = async (id) => {
  const response = await axiosClient.delete(`/api/admin/vps-hosting-requests/${id}`);
  return unwrapApiResponse(response);
};
